export const getMonthsBetweenDates = (fistDate, lastDate) => {
  const resultList = [];
  const date = new Date(fistDate.toString());
  const endDate = new Date(lastDate.toString());
  const monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  while (date <= endDate) {
    resultList.push(`${date.getFullYear()}/${monthList[date.getMonth()]}`);
    date.setMonth(date.getMonth() + 1);
  }

  return resultList;
};
